import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { VerificationAamva } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { US_STATES } from 'lib/constants/locales';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

const ChecksInformationRow = styled('div')`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: ${Spacing[4]};
`;

interface AamvaVerificationProps extends VerificationDetailProps {
  verification: VerificationAamva;
}

const AamvaVerification = ({ verification }: AamvaVerificationProps) => {
  const { 'redacted-at': redactedAt, 'issuing-authority': issuingAuthority } =
    verification.attributes;

  const isRedacted = redactedAt != null;

  const checks = verification.attributes.checks;
  const issuingAuthorityStateName = US_STATES[issuingAuthority as keyof typeof US_STATES];

  return (
    <ChecksInformationRow data-test='verification-detail__aamva-verification'>
      <StyledAttributeGrid>
        <Attribute
          label='Issuing Authority'
          value={issuingAuthorityStateName}
          redacted={isRedacted}
        />
      </StyledAttributeGrid>
      {checks && <ChecksTable checks={checks} verification={verification} />}
    </ChecksInformationRow>
  );
};

export default AamvaVerification;
